import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { cos } from "@amcharts/amcharts4/.internal/core/utils/Math";

declare var ko: any;

export class filterAutocomplete_template extends vnTemplate {
  protected delay = 300;
  protected debounceTimerId: number;

  protected getTemplateHtml(): string {
    return /*html*/ `
                <div data-bind="css: { 'is-visible': isClearInputConfirmFormShown }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                              <div class="form-header">
                              </div>
                              <div class="w-form-body">
                                    <div class="form-body" style="width: 100%">
                                        <div class="form-group">
                                            <p class="form-text" data-bind="text: clearInputConfirmMessage"></p>
                                        </div>
                                    </div>
                              </div>
                              <div class="form-footer">
                                    <button class="btn" type="button" data-bind="event: { click: cancelInputClear }">Cancel</button>
                                    <button class="btn highlight" type="button" data-bind="event: { click: onConfirmInputChange }">Confirm</button>
                              </div>
                        </div>
                    </div>
                </div>

                <div data-bind="attr: { id : elementIdentifier() + '_container' }" class="w-autocomplete">
                        <div class="w-spec-search icon i-auto-complete i-tag-a" data-bind="visible: isVisible,  class: filterIconCSSClass, css: { '' : label() , 'loading': isLoading }">
                            <label class="form-label" data-bind="text: 'Select ' + label(), visible: label() && !addNewSelected()"></label>

                            <input autocomplete="off" data-bind="enable: !isGlobalLockEnabled() && !addNewSelected(), click: onInputClick, textInput: inputText, event: { keyup: onInputChange }, valueUpdate : ['afterkeydown','propertychange','input'], attr:{ id: elementIdentifier() + '_input', placeholder: placeholder, readonly : isPublishingControl}, css: { 'is-disable' : addNewSelected() }" class="input-text">
                            <!-- ko if: optionsLoading -->
                            <span class="form-loading" ></span>
                             <!-- /ko -->
                                                    <button data-bind="event: { click: onClearInput }, attr: { id : 'autocomplete-input-close-' + elementIdentifier() }" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                        </div>

                        <div data-bind="if: optionObj() && isShowCurrentSelection()" class="current-selection">
                            <span data-bind="attr: {title: optionObj().name}, visible: optionObj() && !addNewSelected(), text: optionObj().name "></span>
                            <button data-bind="attr: {id: 'user-input-close_' + elementIdentifier()}, event: { click: promptInputChange.bind($data, 'clear') }, visible: optionObj() && !addNewSelected()" class="btn-form icon i-close" type="button"><span class="hidden-text"></span></button>
                        </div>

                        <div>
                            <button class="btn-add-new icon i-dropdown-simple" type="button" data-bind="visible: addNewOptionEnabled(), css:{ 'is-open': addNewSelected() }, click: promptInputChange.bind($data, 'add new')  ">Add New<p>
                        </div>
                        <div data-bind="visible: isShowOptionSuggestions">
                            <div data-bind="if: hasDisplayNameComplement">
                                  <ul class="form-auto-list" data-bind="foreach: options, attr: { 'id': elementIdentifier() + '_datalist_ul' } "><!--  -->
                                    <!-- ko ifnot: $parent.showDetails() -->
                                     <li class="form-auto-item" data-bind="css: {'is-active':(isSelectable == 1)}, text: displayNameComplement, value: name, click: $parent.promptInputChange.bind($data, 'option click')"></li>
                                    <!-- /ko -->
                                    <!-- ko if: $parent.showDetails() -->
                                    <li class="form-auto-item" data-bind="css: {'is-active':(isSelectable == 1)}, value: name, click: $parent.promptInputChange.bind($data, 'option click')">
                                        <span class="title" data-bind="text: displayNameComplement"></span>
                                        <span class="date">ID:
                                            <span data-bind="text: id ?? ''"></span>
                                        </span>
                                        <span class="date">Last Published:
                                            <span data-bind="text: $data.dateMostRecentPublishedStatus ? $data.dateMostRecentPublishedStatus : 'Never Published'"></span>
                                        </span>
                                    </li>
                                    <!-- /ko -->
                                  </ul>
                            </div>
                            <div data-bind="ifnot: hasDisplayNameComplement">
                                <ul class="form-auto-list" data-bind=" foreach: options, attr: { 'id': elementIdentifier() + '_datalist_ul' }">
                                    <!-- ko ifnot: $parent.showDetails() -->
                                    <li class="form-auto-item" data-bind="css: {'is-active':(isSelectable == 1)}, text: name, value: name, click: $parent.promptInputChange.bind($data, 'option click')"></li>
                                    <!-- /ko -->
                                    <!-- ko if: $parent.showDetails() -->
                                    <li class="form-auto-item" data-bind="css: {'is-active':(isSelectable == 1)}, value: name, click: $parent.promptInputChange.bind($data, 'option click')">
                                        <span class="title" data-bind="text: name"></span>
                                        <span class="date">ID:
                                            <span data-bind="text: id ?? ''"></span>
                                        </span>
                                        <span class="date">Last Published:
                                            <span data-bind="text: $data.dateMostRecentPublishedStatus ? $data.dateMostRecentPublishedStatus : 'Never Published'"></span>
                                        </span>
                                    </li>
                                    <!-- /ko -->
                                </ul>
                            </div>
                        </div>
                        <div class="add-new-section" data-bind="css: { 'is-activated' : addNewSelected() }">
                            <div class="inside-label">
                                <label class="form-label" data-bind="visible: addNewSelected(),text: 'New ' + label ()"></label>
                                <input autocomplete="off" class="w-right input-text" type="text"  data-bind="visible: addNewSelected(), click: onAddNewInputClick, event: { keyup: onAddNewInputChange },  value: newOptionName, valueUpdate : ['afterkeydown','input', 'textchange'], attr:{ id: elementIdentifier() + '_addNewInput'}"/>
                            </div>
                            <div data-bind="if: suggestedObj(), click: acceptSuggestion">
                                <p class="suggestion" data-bind="text: 'Do you mean : '+suggestedObj().name+'? (This tag already exists, click here to select it)'"></p>
                            </div>
                            <div data-bind="visible: isVisible && addNewOptionEnabled"></div>
                        </div>
                </div>
                `;
  }

  protected buildViewModel(): any {
    let that = this;
    return {
      options: ko.observableArray([]),
      isLoading: ko.observable(false),
      inputText: ko.observable(""),
      hasDisplayNameComplement: ko.observable(false),
      addNewSelected: ko.observable(false),
      newOptionName: ko.observable(""),
      suggestedObj: ko.observable(null),
      addNewOptionEnabled: ko.observable(false),
      optionsLoading: ko.observable(false),
      optionObj: ko.observable(null),
      placeholder: ko.observable(""),
      optionType: ko.observable("option"),
      optionInStandby: ko.observable(null),
      numberOfCharsAutocomplete: ko.observable(3),
      label: ko.observable(""),
      orderBy: ko.observable("dateCreation"),
      isAddButtonVisible: ko.observable(false),
      orderByDirection: ko.observable("DESC"),
      filterIconCSSClass: ko.observable(null),
      isVisible: ko.observable(true),
      isShowOptionSuggestions: ko.observable(false),
      elementIdentifier: ko.observable(this.idElement),
      hasInputClearConfirmPrompt: ko.observable(false),
      hasAddNewClearConfirmPrompt: ko.observable(false),
      isClearInputConfirmFormShown: ko.observable(false),
      isShowCurrentSelection: ko.observable(true),
      promptSource: ko.observable(""),
      clearInputConfirmMessage: ko.observable(
        "Are you sure you want to clear this input?"
      ), //Default value, can be set to something else
      addNewClearInputConfirmMessage: ko.observable(
        "Are you sure you want to add a new item? This will clear the input"
      ), //Default value, can be set to something else
      isPublishingControl: ko.observable(false),
      isGlobalLockEnabled: ko.observable(false),
      showDetails: ko.observable(false),
      promptInputChange: function (value, data, event) {
        that.promptInputChange(value, data);
      },
      onInputChange: function (data, event) {
        that.debouncedOnInputChange(data, event);
      },
      onConfirmInputChange: function (data, event) {
        that.onConfirmInputChange();
      },
      cancelInputClear: function (data, event) {
        that.cancelInputClear();
      },
      onInputClick: function (value, data, event) {
        that.onInputClick(value, data, event);
      },
      onClearInput: function (data, event) {
        that.onClearInput(event);
      },
      onAddNewInputClick: function (value, data, event) {
        that.onAddNewInputClick(value, data, event);
      },
      onAddNewInputChange: function (data, event) {
        that.onAddNewInputChange(data, event);
      },
      acceptSuggestion: function (value, data, event) {
        that.acceptSuggestion();
      },
    };
  }

  protected cancelInputClear() {
    this.getTemplateViewModel().isClearInputConfirmFormShown(false);
  }

  public setHasAddNewClearConfirmPrompt(bool: boolean) {
    this.getTemplateViewModel().hasAddNewClearConfirmPrompt(bool);
  }

  public setAddNewClearConfirmMessage(message: string) {
    this.setHasAddNewClearConfirmPrompt(true);
    this.getTemplateViewModel().addNewClearInputConfirmMessage(message);
  }

  public setClearInputConfirmMessage(message: string) {
    this.setHasInputClearConfirmPrompt(true);
    this.getTemplateViewModel().clearInputConfirmMessage(message);
  }

  public setHasDisplayNameComplement(bool: boolean) {
    this.getTemplateViewModel().hasDisplayNameComplement(bool);
  }

  public setHasInputClearConfirmPrompt(bool: boolean) {
    this.getTemplateViewModel().hasInputClearConfirmPrompt(bool);
  }

  protected promptInputChange(source, data) {
    let viewModel = this.getTemplateViewModel();
    let hasPrompt: boolean;

    //Source can either be clear or optionClick
    if (source == "option click") {
      if (
        this.caller &&
        typeof this.caller.onPromptInputChangeClear === "function"
      ) {
        this.caller.onPromptInputChangeClear(this.idElement);
      }

      hasPrompt =
        viewModel.hasInputClearConfirmPrompt() && viewModel.optionObj();

      if (!hasPrompt) {
        if (viewModel.optionObj()) {
          if (viewModel.optionObj().id != data.id) {
            this.setOption(data);
            if (typeof this.caller.getTagTypeFields === "function") {
              this.caller.getTagTypeFields(data.id);
            }
          }
        } else {
          this.setOption(data);
          if (typeof this.caller.getTagTypeFields === "function") {
            this.caller.getTagTypeFields(data.id);
          }
        }
      } else {
        this.getTemplateViewModel().optionInStandby(data);
      }
    } else if (source == "clear") {
      hasPrompt =
        viewModel.optionObj() != null && viewModel.hasInputClearConfirmPrompt();

      if (!hasPrompt) {
        this.clearInput();
      }

      if (
        this.caller &&
        typeof this.caller.onPromptInputChangeClear === "function"
      ) {
        this.caller.onPromptInputChangeClear(this.idElement);
      }
    } else if (source == "add new") {
      hasPrompt =
        (viewModel.hasAddNewClearConfirmPrompt() &&
          viewModel.optionObj() != null) ||
        (viewModel.addNewSelected() && viewModel.newOptionName() != "");

      if (!hasPrompt) {
        this.addNew();
      }
    }

    if (hasPrompt) {
      this.getTemplateViewModel().promptSource(source);
      this.getTemplateViewModel().isClearInputConfirmFormShown(true);
    }
  }

  protected onConfirmInputChange() {
    let promptSource = this.getTemplateViewModel().promptSource();

    if (promptSource == "clear") {
      this.clearInput();
    } else if (promptSource == "option click") {
      this.setOption(this.getTemplateViewModel().optionInStandby());
    } else if (promptSource == "add new") {
      this.getTemplateViewModel().newOptionName("");
      this.addNew();
    }

    this.getTemplateViewModel().isClearInputConfirmFormShown(false);
  }
  public getOptionObj() {
    return this.getTemplateViewModel().optionObj();
  }
  public getNewOptionName() {
    return this.getTemplateViewModel().newOptionName();
  }
  public setOption(option: any) {
    let button = document.getElementById(
      "autocomplete-input-close-" + this.idElement
    );
    if (button && button.classList.contains("is-showing")) {
      button.classList.remove("is-showing");
    }
    this.getTemplateViewModel().isShowOptionSuggestions(false);
    this.getTemplateViewModel().optionObj(option);
    this.getTemplateViewModel().inputText("");
    this.caller.onAutocompleteOptionChange(this.idElement);
  }

  protected acceptSuggestion() {
    this.getTemplateViewModel().optionObj(
      this.getTemplateViewModel().suggestedObj()
    );
    this.getTemplateViewModel().inputText(
      this.getTemplateViewModel().suggestedObj().name
    );
    this.getTemplateViewModel().suggestedObj(null);
    this.getTemplateViewModel().addNewSelected(false);

    this.caller.onAutocompleteAcceptSuggestion(this.idElement);
  }

  protected onClearInput(event) {
    this.clearInput();
  }

  protected addNew() {
    let addNewSelected = this.getTemplateViewModel().addNewSelected();
    let addedNewOption = false;

    if (!addNewSelected && this.getTemplateViewModel().inputText()) {
      this.getTemplateViewModel().newOptionName(
        this.getTemplateViewModel().inputText()
      );
      addedNewOption = true;
    }
    this.clearInput();

    this.getTemplateViewModel().addNewSelected(!addNewSelected);

    if(!addNewSelected){
      const inputElement = document.querySelector('#'+this.idElement + ' .w-right.input-text') as HTMLInputElement | null;

      if(inputElement){
        inputElement.focus();
      }
    }else{
       const inputElement = document.querySelector('#'+this.idElement + ' .input-text') as HTMLInputElement | null;

      if(inputElement){
        inputElement.focus();
      }
    }


    this.caller.onAutocompleteAddNewSelected(this.idElement);

    if (addedNewOption) {
      this.caller.onAutocompleteAddNewInputChange();
    }
  }

  protected onInputClick(value, data, event) {
    this.caller.onAutocompleteInputClick(this.idElement);
  }

  protected onAddNewInputClick(value, data, event) {
    this.caller.onAutocompleteAddNewInputClick(this.idElement);
  }

  protected onAddNewInputChange(data, event) {
    let inputVal = event.target.value;
    if (inputVal.length != 0) {
      this.caller.onAutocompleteAddNewInputChange(this.idElement);
    } else {
      this.getTemplateViewModel().suggestedObj(null);
    }
  }

  protected getTemplateName(): string {
    return "filterAutocomplete_template";
  }

  public setAddNewOptionEnabled(bool: boolean) {
    this.getTemplateViewModel().addNewOptionEnabled(bool);
  }

  protected debouncedOnInputChange(data, event) {
    clearTimeout(this.debounceTimerId);
    let self = this;
    this.debounceTimerId = window.setTimeout(function () {
      self.onInputChange(data, event);
    }, this.delay);
  }

  protected onInputChange(data, event) {
    let button = document.getElementById(
      "autocomplete-input-close-" + this.idElement
    );
    if (button && !button.classList.contains("is-showing")) {
      button.classList.add("is-showing");
    }

    let inputVal = event.target.value,
      options = this.getTemplateViewModel().options();

    if (
      inputVal.length >= this.getTemplateViewModel().numberOfCharsAutocomplete()
    ) {
      this.getTemplateViewModel().optionsLoading(true);
      this.caller.getSuggestions(inputVal, this.idElement);
      this.getTemplateViewModel().isShowOptionSuggestions(true);
    } else {
      this.getTemplateViewModel().options([]);
      this.getTemplateViewModel().isShowOptionSuggestions(false);
    }
  }

  public clearInput() {
    let button = document.getElementById(
      "autocomplete-input-close-" + this.idElement
    );
    if (button && button.classList.contains("is-showing")) {
      button.classList.remove("is-showing");
    }
    this.getTemplateViewModel().options([]);
    this.clearSelectedOption();
    this.getTemplateViewModel().inputText("");

    this.caller.onAutocompleteInputClear(this.idElement);
  }

  public clearInputNoCallback() {
    let button = document.getElementById(
      "autocomplete-input-close-" + this.idElement
    );
    if (button && button.classList.contains("is-showing")) {
      button.classList.remove("is-showing");
    }
    if (button && button.classList.contains("is-disable")) {
      button.classList.remove("is-disable");
    }
    this.getTemplateViewModel().options([]);
    this.clearSelectedOption();
    this.getTemplateViewModel().inputText("");
  }

  public clearSelectedOption() {
    try {
      this.getTemplateViewModel().optionObj(null);
    } catch (error) {}
  }

  public clearEverything() {
    this.clearInput();
    this.getTemplateViewModel().addNewSelected(false);
    this.getTemplateViewModel().newOptionName("");
    this.getTemplateViewModel().suggestedObj(null);
    this.setOptions([]);
  }

  public setIsVisible(isVisible) {
    this.getTemplateViewModel().isVisible(isVisible);
  }

  public setInputText(inputText) {
    this.getTemplateViewModel().inputText(inputText);
  }

  public setPlaceholder(placeholder: string) {
    this.getTemplateViewModel().placeholder(placeholder);
  }

  public setLabel(label: string) {
    this.getTemplateViewModel().label(label);
  }

  protected unsetLabel() {
    this.getTemplateViewModel().label("");
  }

  public setPlaceholderAndLabel(value: string) {
    this.setLabel(value);
    this.setPlaceholder(value);
  }

  public setFilterIconCSSClass(cssClass: string) {
    this.getTemplateViewModel().filterIconCSSClass(cssClass);
  }

  public setOrderBy(OrderBy: string) {
    this.getTemplateViewModel().orderBy(OrderBy);
  }

  public setOrderByDirection(direction: string) {
    this.getTemplateViewModel().orderByDirection(direction);
  }

  public setFullOrderBy(OrderBy: string, direction: string) {
    this.setOrderBy(OrderBy);
    this.setOrderByDirection(direction);
  }

  public setOptions(options: any) {
    for (let option of options) {
      if (option.isSelectable == undefined) {
        option.isSelectable = true;
      }
    }
    this.getTemplateViewModel().options(options);
    this.getTemplateViewModel().optionsLoading(false);
  }

  public setNumberOfChars(numberOfChars: number) {
    this.getTemplateViewModel().numberOfCharsAutocomplete(numberOfChars);
  }

  public setNewOptionName(newOptionName) {
    this.getTemplateViewModel().newOptionName(newOptionName);
  }

  public setIsLoading(bool: boolean) {
    this.getTemplateViewModel().isLoading(bool);
  }

  public setOptionType(optionType: string) {
    this.getTemplateViewModel().optionType(optionType);
  }

  public toggleAddNew(){
    this.addNew();
  }

  public setIsShowCurrentSelection(bool: boolean) {
    this.getTemplateViewModel().isShowCurrentSelection(bool);
  }

  public setIsPublishingControl(value: boolean) {
    this.getTemplateViewModel().isPublishingControl(value);
  }

  public setIsGlobalLockEnabled(value: boolean) {
    this.getTemplateViewModel().isGlobalLockEnabled(value);
  }

  public setShowDetails(boolean) {
    this.getTemplateViewModel().showDetails(boolean);
  }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterAutocomplete_template.ts